/**
 * Numedia Logo — striped sphere silhouette,
 * filled with the Aurora gradient (indigo → purple → pink).
 *
 * Uses CSS mask-image with /numedia-logo-mask.png (alpha mask).
 * Variant "light" → gradient on white/light backgrounds.
 * Variant "dark"  → lighter gradient on dark backgrounds.
 */
export default function Logo({ size = 40, variant = "light", className = "" }) {
  const gradient =
    variant === "dark"
      ? "linear-gradient(135deg, #818CF8 0%, #C084FC 50%, #F9A8D4 100%)"
      : "linear-gradient(135deg, #6366F1 0%, #A855F7 50%, #EC4899 100%)";

  // Original PNG ratio (w/h) — almost square sphere
  const aspect = 202 / 213;

  return (
    <span
      data-testid="numedia-logo"
      aria-hidden="true"
      className={`inline-block shrink-0 ${className}`}
      style={{
        width: `${size * aspect}px`,
        height: `${size}px`,
        background: gradient,
        WebkitMaskImage: "url('/numedia-logo-mask.png')",
        maskImage: "url('/numedia-logo-mask.png')",
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
      }}
    />
  );
}
